const components: { [key: string]: React.FC<unknown> } = {};

export default components;
